"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addModuleRouter = exports.useModuleRouterSync = void 0;
/* eslint-disable max-len */
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var use_previous_1 = __importDefault(require("use-previous"));
var uuid_1 = require("uuid");
var uniqueRouterID = (0, uuid_1.v4)();
var useModuleRouterSync = function () {
    var location = (0, react_router_dom_1.useLocation)();
    var previousLocation = (0, use_previous_1.default)(location);
    (0, react_1.useEffect)(function () {
        var _a;
        if (location.pathname !== (previousLocation === null || previousLocation === void 0 ? void 0 : previousLocation.pathname) || location.search !== (previousLocation === null || previousLocation === void 0 ? void 0 : previousLocation.search)) {
            (_a = window.moduleRouters) === null || _a === void 0 ? void 0 : _a.forEach(function (_a) {
                var routerId = _a.routerId, router = _a.router;
                if (routerId !== uniqueRouterID) {
                    router.navigate(location.pathname + location.search, { replace: true });
                }
            });
        }
    }, [location, previousLocation]);
};
exports.useModuleRouterSync = useModuleRouterSync;
/**
 * See documentation for `ModuleRouterSync` for usage details.
 */
var addModuleRouter = function (router) {
    if (!window.moduleRouters) {
        window.moduleRouters = [];
    }
    var existingRouterIndex = window.moduleRouters.findIndex(function (moduleRouter) { return moduleRouter.routerId === uniqueRouterID; });
    if (existingRouterIndex !== -1) {
        throw new Error("A router with routerId '".concat(uniqueRouterID, "' is already registered. Each router must have a unique routerId."));
    }
    window.moduleRouters.push({ routerId: uniqueRouterID, router: router });
};
exports.addModuleRouter = addModuleRouter;
